import {filehttpToken,httpToken} from '@/utils/http'
import {translateBase64ToArrayBuffer,download_file} from '@/utils/server/file'
import qs from "qs";
// let msgbox = require('element-ui')

// 图片展示
export function imgshow(url) {
  return filehttpToken({
    url: url,
    responseType:'arraybuffer',
    method: 'get',
  })
}
// 根据url 和 库点unit进行文件展示
export function imgshow2(url,unit=JSON.parse(sessionStorage.getItem('user')).unitId) {
  return filehttpToken({
    url: "/sys-file2/downloadFileOs2",
    method: "post",
    data:qs.stringify({
      url:url,
      unit:unit
    }),
  })
}
// 根据id进行文件展示
export function imgshow3(id) {
  return httpToken({
    method: "get",
    url: "/sys-file2/downloadFile2?id="+id
  })
}
// 文件下载方法  跟据文件id进行下载
export function downloadFile(id) {
  httpToken({
    method: "get",
    url: "/sys-file2/downloadFile2?id="+id
  }).then((res)=>{
    if(res.data.code==200){
      const fileName = decodeURIComponent(res.headers["filename"])
      download_file(translateBase64ToArrayBuffer(res.data.data),fileName)
    }
  })
}
// 文件打印方法
export function recordPrint(data,fileName) {
  httpToken({
    method: "post",
    data:data,
    url: "/group-check-record/print"
  })
  .then((res)=>{
    // console.log('文件打印方法222',res)
    if(res.data.code==200){
      download_file(translateBase64ToArrayBuffer(res.data.data),fileName)
    }
  })
}